import React from 'react';

// Fixed +91 prefix, digits-only, capped at 10 — mirrors the mobile apps'
// login screens so the value collected here is always exactly what the
// backend's isValidMobileNum expects once "+91" is prepended.
export const MobileInput = ({ value, onChange, name = 'mobile', disabled = false, required = true }) => (
  <div className="flex items-center rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 focus-within:ring-2 focus-within:ring-indigo-500/40 focus-within:border-indigo-500 transition-all duration-150 overflow-hidden">
    <span className="pl-3 pr-2 py-2 text-sm text-gray-500 dark:text-gray-400 border-r border-gray-200 dark:border-gray-700 select-none">+91</span>
    <input
      type="tel"
      inputMode="numeric"
      autoComplete="off"
      name={name}
      value={value}
      onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 10))}
      className="flex-1 min-w-0 px-3 py-2 bg-transparent text-sm text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none"
      placeholder="10-digit mobile number"
      maxLength={10}
      required={required}
      disabled={disabled}
    />
  </div>
);
